import type { FC } from 'react';

import type {
  MultiSelectFilterFieldLabels,
  MultiSelectFilterItemDisplay,
} from './types';
import { getInitials } from './utils';

import styles from './multi_select_filter_chip.module.css';

type ItemChipProps = {
  item: MultiSelectFilterItemDisplay;
  showItemAvatar?: boolean;
};

export const MultiSelectFilterItemChip: FC<ItemChipProps> = ({
  item,
  showItemAvatar = true,
}) => {
  const noAvatar = !item.imageUrl && !showItemAvatar;
  return (
    <span
      className={`${styles.chip}${noAvatar ? ` ${styles.chip_no_avatar}` : ''}`}
    >
      {item.imageUrl ? (
        <img
          src={item.imageUrl}
          alt=""
          className={item.imageType === 'logo' ? styles.logo : styles.avatar}
        />
      ) : null}
      {!item.imageUrl && showItemAvatar ? (
        <span className={styles.initials} data-ui="chip-initials">
          {getInitials(item.label)}
        </span>
      ) : null}
      <span className={styles.label}>{item.label}</span>
    </span>
  );
};

type SummaryChipProps = {
  count: number;
  itemLabels: MultiSelectFilterFieldLabels;
};

export const MultiSelectFilterSummaryChip: FC<SummaryChipProps> = ({
  count,
  itemLabels,
}) => {
  return (
    <span className={styles.summary_chip}>
      {count} {count === 1 ? itemLabels.singular : itemLabels.plural}
    </span>
  );
};
